import { render, staticRenderFns } from "./DeleteFileComponent.vue?vue&type=template&id=1594e7c2&scoped=true&"
import script from "./DeleteFileComponent.vue?vue&type=script&lang=js&"
export * from "./DeleteFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteFileComponent.vue?vue&type=style&index=0&id=1594e7c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1594e7c2",
  null
  
)

export default component.exports